export default "__VITE_ASSET__kaNAwePm__"